// src/utils/subscriptionUtils.js

export const getSubscriptionState = (subscription) => {
  // Gracefully handle cases where there is no subscription
  if (!subscription) {
    return {
      dateLabel: "No Active Plan",
      actionButtonTitle: "Subscribe Now",
      isCancellable: false,
      isSeatUpdatable: false,
      canManageUsers: false,
    };
  }

  // Rule: A subscription is only seat-updatable if it's an active, non-trial plan.
  const isSeatUpdatable =
    subscription.isActive && subscription.type !== "trial";

  // Rule: A subscription is only cancellable if it's an active, non-trial plan.
  const isCancellable = subscription.isActive && subscription.type !== "trial";

  // Rule: Users can be managed as long as the subscription is active (incl. trial).
  const canManageUsers = subscription.isActive;

  if (subscription.isActive) {
    const dateLabel =
      subscription.type === "trial" ? "Trial Ends" : "Next Billing";
    return {
      dateLabel,
      actionButtonTitle: "Update Plan",
      isCancellable,
      isSeatUpdatable,
      canManageUsers,
    };
  }

  if (subscription.isCancelled) {
    return {
      dateLabel: "Ends On",
      actionButtonTitle: "Subscribe Now",
      isCancellable: false,
      isSeatUpdatable: false,
      canManageUsers: true,
    };
  }

  if (subscription.isExpired) {
    return {
      dateLabel: "Expired On",
      actionButtonTitle: "Subscribe Now",
      isCancellable: false,
      isSeatUpdatable: false,
      canManageUsers: false,
    };
  }

  // Default state for pending or other statuses
  return {
    dateLabel: "Starts On",
    actionButtonTitle: "Update Plan",
    isCancellable: true, // A pending plan can often be cancelled
    isSeatUpdatable: false,
    canManageUsers: false, // Cannot manage users until the plan is active
  };
};
